var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.39 114.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff4ab;\n        stroke-width: 5.16px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 4.74px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.02,2.37l-10.46,106.3-3.23.84c-12.91,3.34-31.49,3.29-44.38-.12l-4.2-1.11L2.37,2.81l77.65-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.04,19.09l-5.71,75.66c-9.16,2.93-18.74,2.32-27.95-.13L19.87,20.12c2.65.84,6.25,5.19,9.08,4.76,3.78-.54,7.29-1.9,10.68-3.31,1.65-.67,3.36-1.39,5.19-1.26,1.22.1,2.32.54,3.39.99,2.59,1.11,5.16,2.3,7.99,2.94,2.44.57,5.49-4.38,7.84-5.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrs);
export default __webpack_public_path__ + "static/media/ORS.ad8c33455998dfa9f156ff45b74a46b7.svg";
export { ForwardRef as ReactComponent };